import React from 'react';

function Footer() {
  return (
    <footer className="app-footer">
      <div style={{ 
        fontSize: '13px', 
        color: 'rgba(255, 255, 255, 0.95)', 
        marginTop: '20px', 
        padding: '20px', 
        textAlign: 'center', 
        borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        backgroundColor: 'rgba(0, 0, 0, 0.2)'
      }}>
        {/* Links Row */}
        <div style={{ fontSize: '13px', marginBottom: '12px', display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
          <a 
            href="#/terms" 
            style={{ 
              color: 'rgba(255, 255, 255, 0.95)', 
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'opacity 0.3s ease'
            }} 
            onClick={(e) => { e.preventDefault(); window.location.hash = '/terms'; }}
            onMouseOver={(e) => e.target.style.opacity = '0.8'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            תנאי שימוש
          </a>
          <span style={{ color: 'rgba(255, 255, 255, 0.5)' }}>|</span>
          <a 
            href="#/privacy" 
            style={{ 
              color: 'rgba(255, 255, 255, 0.95)', 
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'opacity 0.3s ease'
            }} 
            onClick={(e) => { e.preventDefault(); window.location.hash = '/privacy'; }}
            onMouseOver={(e) => e.target.style.opacity = '0.8'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            מדיניות פרטיות
          </a>
        </div>

        {/* Copyright */}
        <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: 'rgba(255, 255, 255, 0.8)' }}>© 2026 NetoBro</p>
      </div>
    </footer>
  );
}

export default Footer;
